import { getThorInfo, resetThorInfo, getUserInfo } from '@/api/user'
import { checkPinWhite, checkRealNameAuth } from '@/api/node/control'
import $ from 'jquery'

const getDefaultState = () => {
  return {
    name: '',
    privacyAgreementVersion: '1.0.0',
    isHaveThor: false,
    isWhiteAuth: false, // 白名单权限
    isNameAuth: false, // 实名认证
    x86Type: 1 // 1：有菜单栏；2：没有菜单栏
  }
}

const state = getDefaultState()

const mutations = {
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_THOR: (state, val) => {
    state.isHaveThor = val
  },
  SET_WHITE_AUTH: (state, val) => {
    state.isWhiteAuth = val
  },
  SET_NAME_AUTH: (state, val) => {
    state.isNameAuth = val
  }
}

const actions = {
  getThor({ commit }) {
    return new Promise((resolve, reject) => {
      getThorInfo()
        .then(response => {
          const { data } = response
          commit('SET_THOR', data)
          resolve(data)
        })
        .catch(error => {
          commit('SET_THOR', false)
          reject(error && error.response)
        })
    })
  },

  resetThor({ commit }) {
    return new Promise((resolve, reject) => {
      if (process.env.NODE_ENV !== 'development') {
        $.getJSON('https://sso.jdcloud.com/exit?callback=?', function() {
          $.getJSON('https://sso.jd.com/exit?callback=?', function() {
            resolve()
            commit('SET_THOR', false)
          })
        })
      } else {
        resetThorInfo()
          .then(() => {
            resolve()
            commit('SET_THOR', false)
          })
          .catch(error => {
            commit('SET_THOR', false)
            reject(error && error.response)
          })
      }
    })
  },

  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getUserInfo()
        .then(response => {
          const { data } = response
          if (!data) {
            return reject('Verification failed, please Login again.')
          }
          commit('SET_NAME', data.username)
          resolve()
        })
        .catch(error => {
          commit('SET_NAME', '')
          reject(error && error.response)
        })
    })
  },

  handleCheckWhiteAuth({ commit }) {
    return new Promise((resolve, reject) => {
      checkPinWhite()
        .then(() => {
          resolve(true)
          commit('SET_WHITE_AUTH', true)
        })
        .catch(error => {
          commit('SET_WHITE_AUTH', false)
          reject(error && error.response)
        })
    })
  },

  handleCheckNameAuth({ commit }) {
    return new Promise((resolve, reject) => {
      checkRealNameAuth()
        .then((res) => {
          resolve(res.data)
          if (res.data.responseCode === '00000') {
            commit('SET_NAME_AUTH', true)
          } else {
            commit('SET_NAME_AUTH', false)
          }
        })
        .catch(error => {
          commit('SET_NAME_AUTH', false)
          reject(error && error.response)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

